/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  AddBoardToCategoryRequest,
  CreateCategoryRequest,
  CreateCategoryResponse,
  CreateFlexboardRequest,
  CreateFlexboardResponse,
  CreateFlexboardTypeRequest,
  CreateFlexboardTypeResponse,
  DeleteBoardFromCategoryRequest,
  DeleteCategoryRequest,
  DeleteFlexboardRequest,
  DeleteFlexboardTypeRequest,
  DeleteFlexboardTypeResponse,
  DuplicateFlexboardRequest,
  GetBackgroundsResponse,
  GetCategoriesRequest,
  GetCategoriesResponse,
  GetFlexboardTypesRequest,
  GetFlexboardTypesResponse,
  NoData,
  UpdateCategoryRequest,
  UpdateFlexboardRequest,
  UpdateFlexboardTypeRequest,
} from "./models";
import {
  createCategoryResponseSchema,
  createFlexboardResponseSchema,
  createFlexboardTypeResponseSchema,
  deleteFlexboardTypeResponseSchema,
  getBackgroundsResponseSchema,
  getCategoriesResponseSchema,
  getFlexboardTypesResponseSchema,
  noDataSchema,
} from "./schemas";

export class FlexboardApiClient {
  constructor(private caller: ApiCaller) {}

  async getTypes(
    payload: GetFlexboardTypesRequest,
    timeout?: number,
  ): Promise<GetFlexboardTypesResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.types.get",
        variables: {},
      },
      "getTypes",
      payload,
      { schema: getFlexboardTypesResponseSchema, timeout },
    );
  }

  async createType(
    payload: CreateFlexboardTypeRequest,
    timeout?: number,
  ): Promise<CreateFlexboardTypeResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.types.create",
        variables: {},
      },
      "createType",
      payload,
      { schema: createFlexboardTypeResponseSchema, timeout },
    );
  }

  async updateType(
    payload: UpdateFlexboardTypeRequest,
    typeId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.types.${typeId}.update",
        variables: { typeId: String(typeId) },
      },
      "updateType",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteType(
    payload: DeleteFlexboardTypeRequest,
    typeId: string,
    timeout?: number,
  ): Promise<DeleteFlexboardTypeResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.types.${typeId}.delete",
        variables: { typeId: String(typeId) },
      },
      "deleteType",
      payload,
      { schema: deleteFlexboardTypeResponseSchema, timeout },
    );
  }

  async getCategories(
    payload: GetCategoriesRequest,
    timeout?: number,
  ): Promise<GetCategoriesResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.categories.get",
        variables: {},
      },
      "getCategories",
      payload,
      { schema: getCategoriesResponseSchema, timeout },
    );
  }

  async createCategory(
    payload: CreateCategoryRequest,
    timeout?: number,
  ): Promise<CreateCategoryResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.categories.create",
        variables: {},
      },
      "createCategory",
      payload,
      { schema: createCategoryResponseSchema, timeout },
    );
  }

  async updateCategory(
    payload: UpdateCategoryRequest,
    categoryId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.categories.${categoryId}.update",
        variables: { categoryId: String(categoryId) },
      },
      "updateCategory",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteCategory(
    payload: DeleteCategoryRequest,
    categoryId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.categories.${categoryId}.delete",
        variables: { categoryId: String(categoryId) },
      },
      "deleteCategory",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getBackgrounds(timeout?: number): Promise<GetBackgroundsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.backgrounds.get",
        variables: {},
      },
      "getBackgrounds",
      {},
      { schema: getBackgroundsResponseSchema, timeout },
    );
  }

  async createBoard(
    payload: CreateFlexboardRequest,
    timeout?: number,
  ): Promise<CreateFlexboardResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.boards.create",
        variables: {},
      },
      "createBoard",
      payload,
      { schema: createFlexboardResponseSchema, timeout },
    );
  }

  async updateBoard(
    payload: UpdateFlexboardRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.boards.${boardId}.update",
        variables: { boardId: String(boardId) },
      },
      "updateBoard",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteBoard(
    payload: DeleteFlexboardRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.boards.${boardId}.delete",
        variables: { boardId: String(boardId) },
      },
      "deleteBoard",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async duplicateBoard(
    payload: DuplicateFlexboardRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.boards.${boardId}.duplicate",
        variables: { boardId: String(boardId) },
      },
      "duplicateBoard",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async addBoardToCategory(
    payload: AddBoardToCategoryRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.boards.${boardId}.category.set",
        variables: { boardId: String(boardId) },
      },
      "addBoardToCategory",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteBoardFromCategory(
    payload: DeleteBoardFromCategoryRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.flexboard.v1.boards.${boardId}.category.delete",
        variables: { boardId: String(boardId) },
      },
      "deleteBoardFromCategory",
      payload,
      { schema: noDataSchema, timeout },
    );
  }
}
